import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-sparkpost',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>SparkPost icon</title><path d="M16.2 9c-1.351.9-1.8 2.7-1.65 3.9-2.25-2.25 3.45-8.55-3-12.9C15.15 5.4 6 9.75 6 17.4c0 3 1.95 5.701 6 6.6 4.05-.898 6-3.6 6-6.6 0-4.5-2.7-6-1.8-8.4zM12 20.852c-1.8 0-3.45-1.5-3.45-3.451 0-1.801 1.5-3.45 3.45-3.45 1.8 0 3.45 1.5 3.45 3.45-.15 1.951-1.65 3.451-3.45 3.451z"/></svg>`,
    styles: []
})
export class SimpleIconsSparkpostComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FA6423';
    @Input() className: string = 'simple-icons-sparkpost'
    constructor() {}
    ngOnInit(): void {}
}
